import { HList } from '@sleepstation/components-layouts'
import { mq } from '@sleepstation/style-api-helpers'
import { renderList } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'
import { getKeyFromLinks } from '../../helpers'
import BottomHorizontalMenuItem from './BottomHorizontalMenuItem'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled(HList).attrs({ 'data-cy': `bottom-horizontal-menu` })`
  background-color: #032841;

  > * {
    flex-grow: 1;
  }

  ${mq(`mediumUp`)} {
    display: none;
  }
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const BottomHorizontalMenu = ({ links }) => (
  <Layout>
    {renderList(
      ({ linkUrl, iconKey, linkText, showBadge }) => (
        <BottomHorizontalMenuItem
          linkUrl={linkUrl}
          iconKey={iconKey}
          linkText={linkText}
          showBadge={showBadge}
        />
      ),
      links,
      { idFunc: getKeyFromLinks(links) }
    )}
  </Layout>
)

BottomHorizontalMenu.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default BottomHorizontalMenu
